export const toRem = (value: number | string, px: number = 16) => {
  if (typeof value === 'string') value = parseFloat(value);
  return `${value / px}rem`;
}

export const toEm = (value: number, px: number = 16) => {
  if (typeof value === 'string') value = parseFloat(value);
  return `${value / px}em`;
}

export const adaptiveValue = (
  property: string,
  startSize: number,
  minSize: number,
  widthFrom: number = 1920,
  widthTo: number = 360,
  keepSize: number = 0,
) => {
  if (startSize === 0) startSize = 0.000001;
  if (minSize === 0) minSize = 0.000001;

  const widthFromMedia = toEm(widthFrom);
  const widthToMedia = toEm(widthTo);

  const slope = (startSize - minSize) / (widthFrom - widthTo);
  let yIntersection = (-1 * widthTo * slope) + minSize;
  if (yIntersection === 0) yIntersection = 0.000001;

  const flyValue = `${toRem(yIntersection)} + ${slope * 100}vw`;

  let propertyValue = `clamp(${toRem(minSize)}, ${flyValue}, ${toRem(startSize)})`;

  if (minSize > startSize) propertyValue = `clamp(${toRem(startSize)}, ${flyValue}, ${toRem(minSize)})`;

  let answer = '';

  if (keepSize !== 1 && keepSize !== 3) {
    answer += `
      @media (width >= ${widthFromMedia}) {
        ${property}: ${toRem(startSize)};
      }
    `
  }

  answer += `
    @media (${widthToMedia} < width < ${widthFromMedia}) {
      ${property}: ${propertyValue};
    }
  `;

  if (keepSize !== 1 && keepSize !== 2) {
    answer += `
      @media (width <= ${widthToMedia}) {
        ${property}: ${toRem(minSize)};
      }
    `
  }

  return answer;
}

export function serializeParams(params: Record<string, any>) {
    const usp = new URLSearchParams();
    const append = (key: string, value: any) => {
        if (value === undefined || value === null) return;
        if (Array.isArray(value)) {
            value.forEach((v) => append(key, v));
        } else if (typeof value === "object") {
            Object.entries(value).forEach(([k, v]) => append(`${key}[${k}]`, v));
        } else {
            usp.append(key, String(value));
        }
    };
    Object.entries(params).forEach(([k, v]) => append(k, v));
    return usp.toString();
}